<template>
  <div class="container">
    <a-table
      class="tb"
      ref="dragTable"
      highlight-current-row="false"
      rowKey="key"
      :columns="tableColumns"
      :data-source="tableData"
      bordered
      size="middle"
      :scroll="{ x: 'calc(700px + 50%)', y: cusHeight }"
    >
      <template slot="headerName">
        <div class="header-name-area">
          <div class="text-right">时间</div>
          <div class="text-left">进度</div>
          <div class="lineTable"></div>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
const columns = [
  {
    slots: { title: 'headerName' },
    dataIndex: 'name',
    key: 'name',
    width: 120,
    colSpan: 1,
    customRender: (value, row, index) => {
      const obj = {
        children: value,
        attrs: {}
      }
      return obj
    }
  },
  {
    title: 'companyName',
    width: 100,
    colSpan: 0,
    dataIndex: 'companyName'
  },
  {
    title: '1',
    dataIndex: 'age',
    key: 'age',
    width: 200,
    sorter: (a, b) => a.age - b.age
  },
  {
    title: '2',

    dataIndex: 'building',
    key: 'building',
    width: 100
  },

  {
    title: '3',

    dataIndex: 'street',
    key: 'street',
    width: 200
  },
  {
    title: '4',
    dataIndex: 'companyAddress',
    key: 'companyAddress',
    width: 200
  },
  {
    title: '5',
    dataIndex: 'gender',
    key: 'gender',
    width: 80
  }
]

const data = []
for (let i = 0; i < 100; i++) {
  data.push({
    key: i,
    name: 'John Brown',
    age: i + 1,
    street: 'Lake Park',
    building: 'C',
    number: 2035,
    companyAddress: 'Lake Street 42',
    companyName: 'SoftLake Co',
    gender: 'M'
  })
}
export default {
  props: {
    cusHeight: {
      type: Number,
      default: 300
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableColumns: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      data,
      columns
    }
  },
  mounted () {
    // 调用
  },
  methods: {
    // 在改动数据的方法中调用
    add () {
      this.$nextTick(() => this.setDrag())
    }
  }
}
</script>
<style scoped>
.container {
  height: 200px;
  width: 100%
}
.tb {
  width: 100%;
  height: 240px
}
.lineTable {
  content: '';
  position: absolute;
  width: 1px;
  height: 159px;
  top: -60px;
  left: 60px;
  background: #9faab1;
  display: block;
  transform: rotate(-67deg);
}
.header-name-area {
  position: relative;
  width: 120px
}
</style>
